module.exports = __webpack_public_path__ + "static/media/star-light.0f1f8290.svg";